// src/layouts/WebLayout.jsx
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import logo from 'assets/logo.png';

import { Link } from 'react-router-dom';
import { useAuth } from 'lib/auth';

export function WebLayout({ children }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const { user } = useAuth();

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <div className="min-h-screen flex flex-col  text-gray-800">
      <header className="w-full sticky top-0 z-50 bg-white/80 backdrop-blur border-b">
        <div className="max-w-6xl mx-auto px-4 py-3 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2">
            <img src={logo} className="h-6" />
          </Link>

          <div className=""></div>
          <div className=" md:flex items-center text-sm space-x-3 text-gray-600">
            <Link to="/company" className="hover:text-black">
              Company
            </Link>
            {user ? (
              <Link
                to="/app/home"
                className="bg-black text-white px-4 py-2 rounded-xl text-sm font-medium hover:scale-105 transition"
              >
                Back Home
              </Link>
            ) : (
              <Link
                to="/auth/login"
                className="bg-black text-white px-4 py-2 rounded-xl text-sm font-medium hover:scale-105 transition"
              >
                Sign in / Register
              </Link>
            )}
          </div>
        </div>
      </header>

      {/* ===== Main Content ===== */}
      <main className="flex-grow">{children}</main>

      {/* ===== Footer ===== */}
      <footer className="border-t py-10">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-gray-500">© 2026 Dejunk. Built for simplicity.</div>

          <div className="flex gap-6 text-sm">
            <Link to="/terms" className="text-gray-600 hover:text-black">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="text-gray-600 hover:text-black">
              Privacy Policy
            </Link>
            <Link to="/delete-account" className="text-gray-600 hover:text-black">
              Delete Account
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
